import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas, listupdater } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import CutomerDetailPop from '../../component/CutomerDetailPop';

import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';

import * as APIS from "../../utils/service";
import { getMemberinfo, hpHypen, numFormat, useIntersectionObserver } from "../../utils/utils";
import Checkbox from '../../component/Checkbox';
import { Map, DrawingManager, MarkerClusterer, MapMarker, CustomOverlayMap, Polygon } from "react-kakao-maps-sdk"
import { useMediaQuery } from 'react-responsive';
import _ from "lodash"

// 팝업 컴포넌트
import MainPopup from '../main/MainPopup';
import SelectClick from '../../component/SelectClick';


export default function Customer({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const width = window.innerWidth;
    const height = window.innerHeight;
    const managerRef = useRef(null)
    const mapRef = useRef(null);
    const clusterer = useRef(null);
    const location = useLocation();
    const is500 = useMediaQuery({ query: "(max-width : 500px)" });

    const is1220 = useMediaQuery({ query: "(max-width : 1220px)" });
    const buttonStyle = {
        width: 200,
        fontSize: 14,
        fontWeight: 700,
        minHeight: 40
    }
    const leftdivref = useRef(null);

    const target = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);
    const { listupdate } = useSelector(s => s.popupReducer);
    const [config01, setConfig01] = useState(false);

    let statusArrs = [];
    configdata?.consts?.customerStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 99){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    const statusName = statusArrs;

    const { seltypes, category_1s, 
        listset1, 
        listset2, 
        listset3, 
        listset1_2, 
        listset2_2, 
        listset3_2, 
        listset1_3, 
        listset2_3, 
        listset3_3, 
    } = useSelector(state => state.userInfo);

    const MIN_WIDTH = width-190;


    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx}
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx, category_1: x?.category_1}
    })

    let category_1_setting2 = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {labels: x?.title, values: x?.idx}
    })
    let category_2_setting2 = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {labels: x?.title, values: x?.idx, category_1: x?.category_1}
    })

    //console.log(category_2_setting);
    const [memberinfos, setmemberinfos] = useState(''); 

    const [category_1_OptionConsts, setcategory_1_OptionConsts] = useState(category_1_setting);   
    const [category_2_OptionConsts, setcategory_2_OptionConsts] = useState(category_2_setting);   
    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;
    const [category_1, setcategory_1] = useState(firstCategorys);   
    //const [category_2, setcategory_2] = useState(configdata?.consts?.category_2_OptionConsts?.find((x, i) => (x?.category_1 === firstCategorys && i === 0))?.idx); 
    const [category_2, setcategory_2] = useState(''); 
    const [sell_type, setsell_type] = useState('');   


    const [searchwidth, setsearchwidth] = useState(MIN_WIDTH);   
    const [searchwidth2, setsearchwidth2] = useState('100%');   
    const [moverleft, setmoverleft] = useState(MIN_WIDTH-14);   
    const [searchactive, setsearchactive] = useState(0);   
    const [radio1, setradio1] = useState(0);   
    const [searchvar, setsearchvar] = useState('');   
    const [selectorderby, setselectorderby] = useState('0');   
    const [listsetbuttonactive, setlistsetbuttonactive] = useState(false);   
    const [productdetailflag, setproductdetailflag] = useState(false);   
    const [customerdetailflag, setcustomerdetailflag] = useState(false);   
    
    const [productsendflag, setproductsendflag] = useState(false);   
    const [producttogetherflag, setproducttogetherflag] = useState(false);   
    
    const [listselecterviewerlist, setlistselecterviewerlist] = useState([]);   
    
    const [lists, setlists] = useState([]); 

    const [latlng, setlatlng] = useState({lat: 33.450701, lng: 126.570667 });   
    const [mapshowhide, setmapshowhide] = useState(false);   
    const [polylist, setpolylist] = useState([]);   
    const [positions, setpositions] = useState([]);   
    const [productIdx, setproductIdx] = useState(0);   
    const [customerIdx, setcustomerIdx] = useState(0);   
    
    const [togetherinfoData, settogetherinfoData] = useState({});   
    
    const [seldamdang, setseldamdang] = useState(''); 
    const [damdanglist, setdamdanglist] = useState([]); 
    const [SendDatas, setSendDatas] = useState({}); 

    const [mapViewerflag, setmapViewerflag] = useState(false); 

    const [mobilesearchviewflag, setmobilesearchviewflag] = useState(false); 
    const [week, setweek] = useState(moment().subtract('1', 'week').day(0).format());
    const [customers, setcustomers] = useState([]);
    const [popupShow, setpopupShow] = useState(false);
    const [popupTitle, setpopupTitle] = useState('');
    const [popupType, setpopupType] = useState(1);
    const [customeralls, setcustomeralls] = useState([]);
    const [meetings, setmeetings] = useState([]);
    const [configArr, setConfigArr] = useState([]);


    
    const [productlistTh, setproductlistTh] = useState([
        {key: 'status', viewernames: '상태', winsize: 100},
        {key: 'user', viewernames: '담당자', winsize: 80},
        {key: 'customercode', viewernames: '고객번호'},
        {key: 'create_dt', viewernames: '접수일'},
        {key: 'mediation', viewernames: '공동중개'},
        {key: 'meetings', viewernames: '최근미팅'},
        {key: 'meetingslength', viewernames: '미팅횟수'},
        {key: 'citys', viewernames: '희망지역', winsize: 150},
        {key: 'category_2name', viewernames: '종류'},
        {key: 'item_floor_min', viewernames: '희망층'},
        {key: 'item_area_min', viewernames: '희망면적', winsize: 170},
        {key: 'sell_type', viewernames: '형태'}, 
        {key: 'price_all_min', viewernames: '희망가격', winsize: 110}, 
        {key: 'price_real', viewernames: '가용금액'}, 
        {key: 'minvat', viewernames: '최소수수료\n(VAT별도)', winsize: 80}, 
        {key: 'hp', viewernames: '연락처', winsize: 130}, 
        {key: 'bpm', viewernames: '발품맨', winsize: 80},

        //{key: '?????', viewernames: '매물매칭\n(자사/의뢰/공동)', winsize: 100}, 
        //{key: 'memo', viewernames: '비고'}, 
    ]);   
    const [saveproductlistTd, setsaveproductlistTd] = useState([]);   
    const [productlistTd, setproductlistTd] = useState([]);   
    const [polystatus, setpolystatus] = useState(false);   
    const [listsetpopstatus, setlistsetpopstatus] = useState(false);   
    const [ordercreatedt, setordercreatedt] = useState(0);   
    const [checkvalues, setcheckvalues] = useState([]);   
    const [page, setPage] = useState(0);   

    useEffect(() => {
        if(location?.state?.customerpopIdx*1 > 0){
            setcustomerIdx(location?.state?.customerpopIdx);
            setcustomerdetailflag(true);
        }
    }, [location?.state?.customerpopIdx]);

    useEffect(()=>{
        if (location?.state?.type === "insertCustomer"){
            setTimeout(() => {
                setsell_type(location?.state?.sell_type);
                setcategory_1(location?.state?.category_1);
                //setcategory_2(location?.state?.category_2);
            },500)
        }
    },[location?.state])

    useEffect(() => {
        getlists();
    }, []);

    const getlists = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            weekstart: moment(week).format('YYYY-MM-DD'),
            weekend: moment(week).add(6, 'days').format('YYYY-MM-DD'),
            types: 'customer'
        }
        //console.log("sendersendersender", sender);
        APIS.postData('/v1/compony/typedashbord', sender).then(({ data }) => {
            if (data) {
                const {
                    items, customers, blacks, componyblacks, mycomponymembers, allmembers, stayitemcklists, staycustomercklists,
                    company_news_lists, contract_lists, meetings, customeralls, crewlists, itembeforemonths, customerbeforemonths,
                    contractbeforemonths, fincustomers, realdatas, posdatas, statlists, companyUserCount, areaUserCount,
                    outsideCount
                } = data;

                setcustomers(customers);
                setmeetings(meetings);
                setcustomeralls(customeralls);
            }
        }).catch(({ response }) => {
            console.log(response);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }
    
    useEffect(() => {
        getMemberinfo(setmemberinfos, true);
        // if(seltypes){
        //     if(seltypes*1 === 2){
        //         setsell_type('전세');
        //     } else if(seltypes*1 === 3){
        //         setsell_type('월세');
        //     } else {
        //         setsell_type('매매');
        //     }
        // }
        if(category_1s){
            setcategory_1(category_1s);
            //setcategory_2(configdata?.consts?.category_2_OptionConsts?.filter((x, i) => (x?.category_1*1 === category_1s*1))[0]?.idx);
        }

    }, []);
    useEffect(() => {
        if(memberinfos?.compony?.addr){
            let address = memberinfos?.compony?.addr;
            const geocoder = new window.kakao.maps.services.Geocoder();
            geocoder.addressSearch(address, function (result, status) {
              if (status === window.kakao.maps.services.Status.OK) {
                const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
                //console.log(result[0].y, result[0].x);
                setlatlng({lat: result[0].y, lng: result[0].x });
              }
            });
        }
        if(memberinfos){
            if(memberinfos?.level*1 === 3){
                setseldamdang(memberinfos?.idx);
            }
        }
    }, [memberinfos]);
    const [observe, unobserve] = useIntersectionObserver(() => {
        setPage((page) => page + 1);
    });

    useEffect(() => {
        //searchSetlist();
        setpositions([]);
        clusterer?.current?.clear();
        //if(polystatus === false){
            setTimeout(() => {
                const map = mapRef?.current;
                //map?.setLevel(4);
                setTimeout(() => {
                    searchSetlist();
                }, 200);
            }, 200);
        //}

    }, [
        saveproductlistTd, sell_type, ordercreatedt, checkvalues, category_1, category_2, searchvar, selectorderby,
        seldamdang, configArr
    ]);
    const searchSetlist = () => {
        let listSearchArr = saveproductlistTd;
        if(saveproductlistTd?.length > 0 && sell_type !== ''){
            listSearchArr = listSearchArr?.filter(item => item?.sell_type === sell_type);
        }
        if(ordercreatedt*1 === 0){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('idx')){
                    return b.idx - a.idx;
                }
            });
        }
        if(ordercreatedt*1 === 1){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('idx')){
                    return a.idx - b.idx;
                }
            });
        }
        if(ordercreatedt*1 === 2){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('meettingcreatedt')){
                    return b.meettingcreatedt - a.meettingcreatedt;
                }
            });
        }
        if(ordercreatedt*1 === 3){
            let listfilter1 = listSearchArr?.filter(item => item?.meettingcreatedt > 0);
            let listfilter2 = listSearchArr?.filter(item => item?.meettingcreatedt < 0);
            //console.log(listfilter1, listfilter2);
            listfilter1 = listfilter1.sort(function (a, b) {
                if(a.hasOwnProperty('meettingcreatedt')){
                    return a.meettingcreatedt - b.meettingcreatedt;
                }
            });
            listSearchArr = listfilter1.concat(listfilter2);
        }
        if(ordercreatedt*1 === 4){
            let listfilter1 = listSearchArr?.filter(item => item?.meettingcreatedt > 0);
            let listfilter2 = listSearchArr?.filter(item => item?.meettingcreatedt < 0);
            //console.log(listfilter1, listfilter2);
            listfilter1 = listfilter1.sort(function (a, b) {
                if(a.hasOwnProperty('meetingslength')){
                    return a.meetingslength - b.meetingslength;
                }
            });
            listSearchArr = listfilter1.concat(listfilter2);

        }
        if(ordercreatedt*1 === 5){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('meetingslength')){
                    return b.meetingslength - a.meetingslength;
                }
            });
        }
                
        if(ordercreatedt*1 === 6){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('orderprice_sell')){
                    return a.orderprice_sell - b.orderprice_sell;
                }
            });
        }
        if(ordercreatedt*1 === 7){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('orderprice_sell')){
                    return b.orderprice_sell - a.orderprice_sell;
                }
            });
        }

        if(checkvalues?.length > 0){
            //listSearchArr = listSearchArr?.filter(item => item?.statusname === '완료');
            listSearchArr = listSearchArr?.filter(item => (item?.mediations1 > 0 || item?.mediations2 > 0));
        }

        // if(category_1){
        //     listSearchArr = listSearchArr?.filter(item => item?.category_1*1 === category_1*1);
        // }
        if(category_2){
            listSearchArr = listSearchArr?.filter(item => item?.category_2*1 === category_2*1);
        }
        if(searchvar){
            listSearchArr = listSearchArr?.filter(item => 
                (item?.customercode?.includes(searchvar) > 0 ||
                item?.title?.includes(searchvar) > 0 )
            );
        }

        if(selectorderby*1 !== 0){
            console.log(selectorderby, statusArrs?.find(item => item?.idx*1 === selectorderby*1));
            listSearchArr = listSearchArr?.filter(item => item?.statusname === statusArrs?.find(item => item?.idx*1 === selectorderby*1)?.title);
        }
        if(seldamdang*1 > 0){
            listSearchArr = listSearchArr?.filter(item => item?.damdangidx*1 === seldamdang*1 );
        }        
        console.log(
            listSearchArr
        );

        console.log(configArr);
        if(configArr?.length > 0){
            listSearchArr = listSearchArr?.filter(x => configArr.includes(x?.category_2))
        }

        setproductlistTd(listSearchArr);

        
        let sender = {}
        APIS.postData('/v1/item/list', sender).then(({ data }) => {
            let datas = data?.list;
            if(datas){
                let clustorlist = [];

                let clustorsetlist = datas;
                clustorsetlist = clustorsetlist?.filter(item => item?.sell_type === sell_type);
                if(category_1){
                    clustorsetlist = clustorsetlist?.filter(item => item?.category_1*1 === category_1*1);
                }
                if(category_2){
                    clustorsetlist = clustorsetlist?.filter(item => item?.category_2*1 === category_2*1);
                }

                clustorsetlist?.map((x, i) => {
                    if(x['lat']*1 > 0){
                        clustorlist.push({idx: x['idx']*1, lat: x['lat']*1, lng: x['lng']*1});    
                    }
                })
                setpositions(clustorlist);
                if(clustorsetlist?.length > 0){
                    setlatlng({lat: clustorsetlist[0]?.lat, lng: clustorsetlist[0]?.lng });
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
                
        //setsearchwidth2(190);
        //sell_type
    }
    useEffect(() => {
        setsearchwidth2(190);
    }, []);
    useEffect(() => {
        let sender = {}
        APIS.postData('/v1/master/users', sender).then(({ data }) => {
            if(data){
                //setdamdanglist(data);
                console.log(data);
                let damdanglistArr = [];
                data?.map((x, i) => {
                    damdanglistArr.push({labels: `${x?.name} ${x?.rank}`, values: x?.idx});
                })
                setdamdanglist(damdanglistArr);

            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
        });  
    }, []);

    useEffect(() => {
        if(listupdate === true){
            dispatch(listupdater({ listupdate: false }));
            listopen();
        }
    }, [listupdate]);

    useEffect(() => {
        listopen();
        setPage(1);
        observe(target.current);
    }, []);

    useEffect(() => {
        let sender = {}
        APIS.postData('/v1/item/list', sender).then(({ data }) => {
            let datas = data?.list;
            if(datas){
                let clustorlist = [];
                datas?.map((x, i) => {
                    if(x['lat']*1 > 0){
                        clustorlist.push({idx: x['idx']*1, lat: x['lat']*1, lng: x['lng']*1});    
                    }
                })
                setpositions(clustorlist);
                if(datas?.length > 0){
                    setlatlng({lat: datas[0]?.lat, lng: datas[0]?.lng });
                }
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });      
    }, []);

    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            rolling: false
        }
        APIS.postData('/v1/customer/list', sender).then(({ data }) => {
            if(data){
                let mediations = data?.mediations;
                let list = data?.list;
                let tdlist = [];
                let now = moment(new Date());
                console.log("1111", list);
                let mediation_stay_counts = 0;
                let mediation_complate_counts = 0;
                list?.map((x, i) => {
                    let pushData = {};
                    productlistTh?.map((x2, i2) => {
                        pushData['mediations'] = null;
                        if(x2?.key !== '?????'){
                            if(x2?.key === 'customercode'){
                                pushData[x2?.key] = ('0000000'+x?.idx).slice(-7);
                            } else if(x2?.key === 'status'){
                                pushData[x2?.key] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.arrays; //0:명칭, 1: 색상, 2: select 여부 y or no
                                pushData['statusname'] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.title;
                            } else if(x2?.key === 'item_room'){
                                pushData[x2?.key] = x['item_room']+"/"+x['item_bathroom']; //
                            } else if(x2?.key === 'create_dt'){
                                pushData[x2?.key] = moment(x[x2?.key]).format('YY/MM/DD'); //
                            } else if(x2?.key === 'update_dt'){
                                let duration = moment.duration(now.diff(x[x2?.key]))
                                let days = duration.asDays();
                                pushData[x2?.key] = parseInt(days) + '일 전'; //
                                pushData['orderupdatedt'] = parseInt(days);
                            } else if(x2?.key === 'user'){
                                pushData[x2?.key] = x?.user?.name+" "+x?.user?.rank; //
                            } else if(x2?.key === 'meetings'){
                                let meetduration = moment.duration(now.diff(x['meetings'][0]?.create_dt))
                                let meetdays = meetduration.asDays();
                                pushData[x2?.key] = x?.meetings?.length > 0 ? parseInt(meetdays) === 0 ? '오늘' : parseInt(meetdays) + '일 전' : '-'; //
                            } else if(x2?.key === 'meetingslength'){
                                pushData[x2?.key] = x?.meetings?.length;
                            } else if(x2?.key === 'price_all_min'){
                                if(x?.sell_type === '월세'){
                                    //pushData[x2?.key] = numFormat(x[x2?.key])+"~"+numFormat(x['price_all_max']);
                                    pushData[x2?.key] = numFormat(x[x2?.key])+"~"+numFormat(x['price_all_max'])+"\n/ "+numFormat(x['price_month_min'])+"~"+numFormat(x['price_month_max']);
                                } else {
                                    pushData[x2?.key] = numFormat(x[x2?.key])+"~"+numFormat(x['price_all_max']);
                                    //pushData[x2?.key] = numFormat(x[x2?.key])+"/"+numFormat(x['price_month_min'])+"~"+numFormat(x['price_month_max']);
                                }
                            } else if(x2?.key === 'item_floor_min'){
                                pushData[x2?.key] = x['item_floor_min']+"~"+x['item_floor_max'];
                            } else if(x2?.key === 'item_area_min'){
                                let minareasize = ((x['item_area_min']*1)/3.3057).toFixed(2)+"평";
                                let maxareasize = ((x['item_area_max']*1)/3.3057).toFixed(2)+"평";
                                pushData[x2?.key] = minareasize+"~"+maxareasize;

                            } else if(x2?.key === 'price_real'){
                                pushData[x2?.key] = numFormat(x[x2?.key]);
                            } else if(x2?.key === 'hp'){
                                pushData[x2?.key] = hpHypen(x[x2?.key]);
                            } else if(x2?.key === 'minvat'){
                                let percent = 0;
                                let setprice = x?.price_all_min;
                                //주택은 category_2가 1,2,3,
                                //오피스텔 4
                                // 그위
                                if(x?.sell_type === '월세'){
                                    if(x?.price_all_min*1 < 5000 && x?.price_month_min*1 <= 20){
                                        setprice = (x?.price_all_min*1) + (x?.price_month_min*70);
                                    } else if(x?.price_all_min*1 >= 5000 && x?.price_all_min*1 < 10000 && x?.price_month_min*1 <= 30){
                                        setprice = (x?.price_all_min*1) + (x?.price_month_min*70);
                                    } else {
                                        setprice = (x?.price_all_min*1) + (x?.price_month_min*100);
                                    }
                                }
                                if(x?.category_2*1 === 1 || x?.category_2*1 === 2 || x?.category_2*1 === 3){
                                    if(x?.sell_type === '매매'){
                                        if(setprice*1 >= 0 && setprice*1 < 5000){
                                            percent = 0.006;
                                        } else if(setprice*1 >= 5000 && setprice*1 < 20000){
                                            percent = 0.005;
                                        } else if(setprice*1 >= 20000 && setprice*1 < 90000){
                                            percent = 0.004;
                                        } else if(setprice*1 >= 90000 && setprice*1 < 120000){
                                            percent = 0.005;
                                        } else if(setprice*1 >= 120000 && setprice*1 < 150000){
                                            percent = 0.006;
                                        } else if(setprice*1 >= 150000){
                                            percent = 0.007;
                                        }
                                    } else {
                                        if(setprice*1 >= 0 && setprice*1 < 5000){
                                            percent = 0.005;
                                        } else if(setprice*1 >= 5000 && setprice*1 < 10000){
                                            percent = 0.004;
                                        } else if(setprice*1 >= 10000 && setprice*1 < 60000){
                                            percent = 0.003;
                                        } else if(setprice*1 >= 60000 && setprice*1 < 120000){
                                            percent = 0.004;
                                        } else if(setprice*1 >= 120000 && setprice*1 < 150000){
                                            percent = 0.005;
                                        } else if(setprice*1 >= 150000){
                                            percent = 0.006;
                                        }
                                    }
                                } else if(x?.category_2*1 === 4){
                                    if(x?.sell_type === '매매'){
                                        if(x?.item_area_min*1 < 85){
                                            percent = 0.005;
                                        } else {
                                            percent = 0.009;
                                        }
                                    } else {
                                        if(x?.item_area_min*1 < 85){
                                            percent = 0.004;
                                        } else {
                                            percent = 0.009;
                                        }
                                    }
                                } else {
                                    percent = 0.009;
                                }
                                let setpricemath = (setprice*percent);
                                pushData[x2?.key] = `약 ${numFormat(Math.ceil(setpricemath))}`;
                            } else if(x2?.key === 'citys'){
                                if(x?.citys?.length > 1){
                                    if(x?.citys[0]?.polygon){
                                        pushData[x2?.key] = '폴리곤설정 외 '+x?.citys?.length;
                                    } else {
                                        pushData[x2?.key] = `${x?.citys[0]?.sido} ${x?.citys[0]?.sigungu} ${x?.citys[0]?.dong} 외 ${x?.citys?.length}`;
                                    }
                                } else {
                                    if(x?.citys[0]?.polygon){
                                        pushData[x2?.key] = '폴리곤설정';
                                    } else {
                                        pushData[x2?.key] = `${x?.citys[0]?.sido} ${x?.citys[0]?.sigungu} ${x?.citys[0]?.dong}`;
                                    }
                                }
                            } else if(x2?.key === 'category_2name'){
                                pushData[x2?.key] = configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx*1 === x['category_2']*1))?.title;
                            } else if(x2?.key === 'mediation'){
                                mediation_stay_counts = mediations?.filter(item => item?.c_idx*1 === x?.idx*1 && item?.status*1 === 1)?.length;
                                mediation_complate_counts = mediations?.filter(item => item?.c_idx*1 === x?.idx*1 && item?.status*1 === 2 && item?.finstatus*1 === 0)?.length;
                                pushData[x2?.key] = [mediation_stay_counts, mediation_complate_counts];
                                pushData['mediations'] = (mediation_stay_counts*1 > 0 || mediation_complate_counts > 0) ? true : null;
                            } else if(x2?.key === 'bpm'){
                                pushData['bpm'] = x?.bpmIdx*1 > 0 ? 'O' : 'X';
                            } else {
                                pushData[x2?.key] = x[x2?.key];
                            }
                            
                        }
                    });
                    //console.log(pushData);
                    pushData['ordercreatedt'] = moment(x['create_dt']).format('YYYYMMDD')*1;
                    pushData['meettingcreatedt'] = x['meetings'][0]?.create_dt ? moment(x['meetings'][0]?.create_dt).format('YYYYMMDD')*1 : -1;
                    pushData['orderprice_sell'] = x['price_all_min']*1;
                    pushData['orderarea_private'] = x['area_private']*1;
                    pushData['category_1'] = x['category_1']*1;
                    pushData['category_2'] = x['category_2']*1;
                    pushData['idx'] = x['idx']*1;
                    pushData['title'] = x['title'];
                    pushData['citysData'] = x['citys'];
                    pushData['damdangidx'] = x?.user?.idx;
                    pushData['mediations1'] = mediation_stay_counts ? mediation_complate_counts : 0;
                    pushData['mediations2'] = mediation_complate_counts ? mediation_complate_counts : 0;
                    tdlist.push(pushData);
                })
                console.log(tdlist);
                setsaveproductlistTd(tdlist);
                setproductlistTd(tdlist);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }

    const dragHandler = (e) => {
        const target = e.currentTarget.parentElement;

        leftdivref?.current?.scrollTo({
            left: 0,
            behavior: "smooth",
        });

        if (!target) return;
      
        const resize = (e2) => {
            const right = target.getBoundingClientRect().left + target.getBoundingClientRect().width;
            const left = e2.clientX;
            let movefixel = MIN_WIDTH-left;
            //console.log(width, left, MIN_WIDTH, (MIN_WIDTH-movefixel), MIN_WIDTH, movefixel);
            if((MIN_WIDTH-movefixel) < 600){
                setsearchwidth(600);
                setmoverleft(587);
                setsearchwidth2(width-600);
                return;
            } else if ((MIN_WIDTH-movefixel) > (width-190)){
                setsearchwidth(width-190);
                setmoverleft((width-190)-14);
                setsearchwidth2(190);
            } else {
                setsearchwidth(MIN_WIDTH-movefixel);
                setmoverleft((MIN_WIDTH-movefixel)-14);
                setsearchwidth2(190+movefixel);
            }
          
        };
      
        document.addEventListener('mousemove', resize);
        // document.addEventListener('mousedown', () => {
        //     setmapshowhide(true);
        // }, { once: true });
        document.addEventListener('mouseup', () => {
            document.removeEventListener('mousemove', resize)
            //setmapshowhide(false);
        }, { once: true });
    }
    const pointsToPath = (points) => {
        return points.map((point) => ({
            lat: point.y,
            lng: point.x,
        }))
    }

    const popupOpen = (title, type) => {
        setpopupShow(!popupShow);
        setpopupTitle(title);
        setpopupType(type);
    }

    const listContent = () => {
        //customeralls
        let allCounts = customeralls?.length;
        let outCounts = customers?.filter(item => item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1)?.length;
        //console.log("allCountsallCounts", allCounts, outCounts, (outCounts/allCounts)*100 );
        console.log(damdanglist);
        return (
            <div className='main_popup_content' style={{ marginBottom: 26 }}>
                {/* <div style={{ paddingBottom: 20 }}>
                    <Select 
                        divwidth={{
                            width: 200
                        }}
                        setValues={setselect}
                        values={select}
                        selectData={[
                            {labels: '전체', values: '전체'},
                            {labels: '고객번호', values: '고객번호'},
                            {labels: '고객명', values: '고객명'},
                            {labels: '최근미팅일', values: '최근미팅일'},
                            {labels: '미팅횟수', values: '미팅횟수'},
                            {labels: '담당자', values: '담당자'},
                            {labels: '자동관리 발송 횟수', values: '자동관리 발송 횟수'},
                        ]}
                    />
                </div> */}

                <div className='main_popup_list_container'>
                    {memberinfos?.level * 1 === 3 &&
                        <div style={{ width: 150, marginBottom: 10 }}>
                            <Select
                                setValues={setseldamdang}
                                values={seldamdang}
                                selectData={([{ labels: '임직원 전체', values: '' }].concat(damdanglist))}

                            />
                        </div>
                    }
                    <div style={{ width: 736 }}>
                        <div className='main_popup_list_index'>
                            <p>고객번호</p>
                            <p>고객명</p>
                            <p>최근미팅일</p>
                            <p>미팅횟수</p>
                            <p>담당자</p>
                            <p style={{ borderRight: 0 }}>자동관리 발송 횟수</p>
                        </div>

                        <div className='main_popup_list_data_box'>
                            {customers?.filter(item => {
                                if (seldamdang * 1 !== 0) {
                                    return item?.auto_status * 1 === 1 && item?.u_idx * 1 === seldamdang * 1;
                                } else {
                                    //return item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1;
                                    if (memberinfos?.level * 1 === 1 || memberinfos?.level * 1 === 2) {
                                        return item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1;
                                    } else {
                                        return item?.auto_status * 1 === 1;
                                    }
                                }
                                //return item;

                            })?.map((x, i) => {
                                let meettinglist = meetings?.filter(item => item?.c_idx * 1 === x?.idx * 1);
                                return (
                                    <div
                                        key={"customerpops"+i} className='main_popup_list_data'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setcustomerIdx(x?.idx);
                                            setcustomerdetailflag(true);
                                        }}
                                    >
                                        <p>{x?.idx}</p>
                                        <p className='textcut_online'>{x?.title}</p>
                                        <p>{meettinglist?.length > 0 ? moment(meettinglist[0]?.create_dt).format('YYYY.MM.DD') : '미팅전'}</p>
                                        <p>{meettinglist?.length}번</p>
                                        <p>{x?.user?.name}</p>
                                        <p>{x?.kakaoSendCount}</p>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                </div>

                {/* <div className='main_popup_list_bottom'>
                    <p className='main'>고객 이탈률{((outCounts / allCounts) * 100).toFixed(1)}%</p>
                    <p className='sub'>등록 된 접수·미팅고객 수 대비 이탈고객 비율</p>
                </div> */}
            </div>
        )
    }

    const setConfigReset = () => {
        setConfigArr([]);
    }
    const changeTitle = (idx) => {
        let result = ""
        if (idx === 2) // 다세대
            result = "빌라·연립"
        if (idx === 3) // 단독/다가구
            result = "원·투룸"
        if (idx === 4)
            result = "주거용 오피스텔"
        if (idx === 8)
            result = "업무용 오피스텔"
        return result
    }
    const maemulCategoryList = (categoryList = []) => {
        if (categoryList.length > 0) {
            const groupList = _.groupBy(categoryList, "category_1")
            return Object.keys(groupList).reduce((arr, key) => {
                if (groupList[key]) {
                    // 이름 변경
                    let changeNameList = groupList[key].map(v => {
                        let changeName = v.title
                        if (v.idx === 2) // 다세대
                            changeName = changeTitle(2)
                        if (v.idx === 3) // 단독/다가구
                            changeName = changeTitle(3)
                        if (v.idx === 4)
                            changeName = changeTitle(4)
                        if (v.idx === 8)
                            changeName = changeTitle(8)
                        return { ...v, title: changeName }
                    })
                    arr.push(changeNameList)
                }
                return arr
            }, [])
        } else {
            return []
        }
    }
    
    return(
        <>
        {customerdetailflag === true  && customerIdx*1 > 0 && <CutomerDetailPop 
            setcustomerdetailflag={setcustomerdetailflag} 
            setproductsendflag={setproductsendflag} 
            setproducttogetherflag={setproducttogetherflag}
            customerIdx={customerIdx}
            setproductIdx={setproductIdx}
            setproductdetailflag={setproductdetailflag} 
            settogetherinfoData={settogetherinfoData}
            setSendDatas={setSendDatas}
        /> }
        {productsendflag === true && <ProductSendPop types={'customer'} productIdx={productIdx} SendDatas={SendDatas} setproductdetailflag={setproductdetailflag} setproductsendflag={setproductsendflag}  /> }
        {producttogetherflag === true && <ProductTogetherPop 
            togetherinfoData={togetherinfoData}  setproductdetailflag={setproductdetailflag} setproducttogetherflag={setproducttogetherflag} 
            setcustomerdetailflag={setcustomerdetailflag}
        /> }
        {productdetailflag === true && productIdx*1 > 0 && <ProductDetailPop 
            setproductdetailflag={setproductdetailflag} 
            setproductsendflag={setproductsendflag} 
            setproducttogetherflag={setproducttogetherflag}
            productIdx={productIdx}
            settogetherinfoData={settogetherinfoData}
            customeropens={true}
            
        /> }

        <Layout header={false} actives={'2'} footters={false} setsell_type={setsell_type} setcategory_1={setcategory_1} setcategory_2={setcategory_2} detailFlag={customerdetailflag}>
            <div
                style={{ width: searchwidth, overflowX: 'auto', overflowY: 'hidden'}}
                className='padding40'
                ref={leftdivref}                
            >
                <div
                    className='productmobilesecrcharea'
                >
                    <div
                        style={{
                            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            gap: 8, position: 'relative'
                        }}
                    >
                        <div style={{ width: 'calc(40% - 40px)'}}>
                            <Select 
                                setValues={setsell_type}
                                values={sell_type}
                                selectData={[
                                    {labels: '전체', values: ''},
                                    {labels: '매매', values: '매매'},
                                    {labels: '전세', values: '전세'},
                                    {labels: '월세', values: '월세'},
                                ]}
                            />                            
                        </div>
                        <div style={{ width: 'calc(30% - 0px)'}}>
                            <Select 
                                styles={{}}
                                setValues={(e) => {
                                    console.log(e);
                                    setcategory_1(e*1);
                                    setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1*1 === e*1))[0]?.values);
                                }} 
                                values={category_1}
                                selectData={category_1_setting2}
                            />                               
                        </div>
                        <div style={{ width: '30%'}}>
                            <Select 
                                styles={{}}
                                setValues={(e) => {
                                    setcategory_2(e*1);
                                }} 
                                values={category_2}
                                selectData={category_2_setting2?.filter((x, i) => x?.category_1*1 === category_1*1)}
                            />                            
                        </div>
                        <div style={{ width: 40}}>
                            <Button 
                                titleimgs={`${mobilesearchviewflag === true ? './images/icons/chevron-up-white.svg' : './images/icons/chevron-down.svg'}`}
                                buttonTxt={''} 
                                className={`listsetbutton ${mobilesearchviewflag === true ? 'active' : ''}`} 
                                styles={{
                                    backgroundColor: mobilesearchviewflag === true ? '#6164A5' : '#fff'
                                }}
                                onPress={() => {
                                    setmobilesearchviewflag(!mobilesearchviewflag)
                                }} 
                            />                            
                        </div>
                    </div>
                    {mobilesearchviewflag === true &&
                    <div style={{ 
                        position: 'absolute', left: 0, top: 45, width: '100%', zIndex: 999, backgroundColor: '#f9f9fd',
                        padding: 12
                    }} className='margint8'>
                        <div
                            style={{
                                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                            }}
                        >
                            <div style={{ width: '50%'}}>
                                <Select 
                                    setValues={setordercreatedt}
                                    values={ordercreatedt}
                                    selectData={[
                                        {labels: '접수일 최신순', values: 0},
                                        {labels: '접수일 과거순', values: 1},
                                        {labels: '최근 미팅 최신순', values: 2},
                                        {labels: '최근 미팅 과거순', values: 3},
                                        {labels: '미팅 횟수 적은 순', values: 4},
                                        {labels: '미팅 횟수 많은 순', values: 5},
                                        {labels: '낮은 가격순', values: 6},
                                        {labels: '높은 가격순', values: 7},
                                    ]}
                                />
                            </div>
                            {memberinfos?.level*1 === 3 &&
                            <div style={{ width: '50%'}}>
                                <Select 
                                    setValues={setseldamdang}
                                    values={seldamdang}
                                    selectData={( [{labels: '전체', values: ''}].concat(damdanglist) )}
                                />
                            </div>              
                            }  
                        </div>
                        <div className='margint8'>
                            <Checkbox
                                linetype={'radioimg'}
                                values={checkvalues}
                                setvalues={setcheckvalues}
                                namevalue={[
                                    {names: '완료 고객 보기', values: 1},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </div> 
                        
                        <div className='margint8'>
                            <Input 
                                className={`inputs`}
                                placeholder="고객번호, 고객명"
                                setValue={setsearchvar}
                                value={searchvar}
                                name="mb_phone"
                                allwaysclearflag={true}
                                searchicons={true}
                                style={{
                                    paddingLeft: 35
                                }}
                            />                   
                        </div> 
                                          
                    </div>
                    }
                </div>                
                <div
                    style={{ width: searchwidth > MIN_WIDTH ? searchwidth-97 : MIN_WIDTH-97 }}
                    className='productsecrcharea'
                >
                    {/* <div className="productsearch padding20">
                        <div className="searchselect">
                            <Button buttonTxt={'매매'} className={`searchbutton ${sell_type === '매매' ? 'active' : ''}`} onPress={() => setsell_type('매매') } />
                            <Button buttonTxt={'전세'} className={`searchbutton ${sell_type === '전세' ? 'active' : ''}`} onPress={() => setsell_type('전세') } />
                            <Button buttonTxt={'월세'} className={`searchbutton ${sell_type === '월세' ? 'active' : ''}`} onPress={() => setsell_type('월세') } />
                        </div>
                        <div className="searchetcselect">
                            <div>
                                <Radios
                                    linetype={'radioimg'}
                                    values={category_1}
                                    setvalues={(e) => {
                                        setcategory_1(e*1);
                                        setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1*1 === e*1))[0]?.values);
                                    }} 
                                    namevalue={category_1_OptionConsts}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                            </div>
                            <div className='margint12'>
                                <Radios
                                    linetype={'checkimg'}
                                    values={category_2}
                                    setvalues={setcategory_2}
                                    namevalue={category_2_setting?.filter((x, i) => x?.category_1*1 === category_1*1)}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                            </div>
                        </div>
                    </div> */}
                    <div className="listselecter" style={{ marginTop: 0 }}>
                        <div style={{ width: 'auto' }}>
                            <div>
                                <Select 
                                    setValues={setordercreatedt}
                                    values={ordercreatedt}
                                    selectData={[
                                        {labels: '접수일 최신순', values: 0},
                                        {labels: '접수일 과거순', values: 1},
                                        {labels: '최근 미팅 최신순', values: 2},
                                        {labels: '최근 미팅 과거순', values: 3},
                                        {labels: '미팅 횟수 적은 순', values: 4},
                                        {labels: '미팅 횟수 많은 순', values: 5},
                                        {labels: '낮은 가격순', values: 6},
                                        {labels: '높은 가격순', values: 7},
                                    ]}
                                />
                            </div>
                            {memberinfos?.level*1 === 3 &&
                            <div>
                                <Select 
                                    setValues={setseldamdang}
                                    values={seldamdang}
                                    selectData={( [{labels: '전체', values: ''}].concat(damdanglist) )}

                                />
                            </div>              
                            }              
                            <div style={{ width: 100 }}>
                                <Select 
                                    setValues={setsell_type}
                                    values={sell_type}
                                    selectData={[
                                        {labels: '전체', values: ''},
                                        {labels: '매매', values: '매매'},
                                        {labels: '전세', values: '전세'},
                                        {labels: '월세', values: '월세'},
                                    ]}
                                />     
                            </div>                   
                            <div>
                                <SelectClick
                                    show={config01}
                                    setShow={(res) => {
                                        setConfig01(res);
                                    }}
                                    styles={{
                                        height: 40,
                                        border: '1px solid #ddd',
                                        boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
                                    }}
                                    styles2={{
                                        fontSize: 14, color: '#000'
                                    }}
                                    // title={'매물 종류'}
                                    title={'매물 종류'}
                                />           
                                {/* 선택 박스 */}
                                {(config01) &&
                                    <div className='mini_map_config_container'>
                                        <div className='mini_map_x_top'>
                                            <img src="./images/icons/x_black.svg" width={is500 ? `40` : `24`}
                                                onClick={() => {
                                                    setConfig01(false);
                                                }}
                                            />
                                        </div>
            
                                        <div className='mini_map_config_box' >
                                            <div className='title' style={{
                                                paddingBottom: undefined
                                            }}>
                                                <p>
                                                    {config01 && '매물 종류'}
                                                </p>
                                            </div>
            
                                            {config01 &&
                                                <>
                                                    <div className='map_cate_box full'
                                                        style={{
                                                            backgroundColor: configArr?.length == 0 ? '#6164A5' : '#f1f1f1',
                                                            marginBottom: 20
                                                        }}
                                                        onClick={() => {
                                                            if (setConfigReset) setConfigReset();
                                                        }}
                                                    >
                                                        <p
                                                            style={{ color: configArr?.length == 0 ? '#fff' : '#333' }}
                                                        >{"전체보기"}</p>
                                                    </div>
                                                    <div className='mini_map_cate_box2'>
                                                        {maemulCategoryList(configdata?.consts?.category_2_OptionConsts).map((list, i) => {
                                                            return <div className='mini_cate_row_box'>
                                                                {list.map((x, i) => {
                                                                    return <div key={"mc_cate_item_" + i}
                                                                        className='map_cate_box full'
                                                                        style={{
                                                                            backgroundColor: configArr?.includes(x?.idx) ? '#6164A5' : '#f1f1f1'
                                                                        }}
                                                                        onClick={() => {
                                                                            if (configArr?.includes(x?.idx)) {
                                                                                setConfigArr(configArr?.filter(v => v != x?.idx));
                                                                            } else {
                                                                                setConfigArr([...configArr, x?.idx]);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{ color: configArr?.includes(x?.idx) ? '#fff' : '#333' }}
                                                                        >{x?.title}</p>
                                                                    </div>
                                                                })}
                                                            </div>
                                                        })}
                                                    </div>
            
                                                    <div className='reset_box' style={{ paddingTop: 12 }}>
                                                        <Button
                                                            buttonTxt={'초기화'}
                                                            className={'resetbutton'}
                                                            titleimgs={`./images/icons/loop-left-line.svg`}
                                                            onPress={() => {
                                                                if (setConfigReset) setConfigReset();
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                }                     
                            </div>  
                            <div>
                                <Checkbox
                                    linetype={'radioimg'}
                                    values={checkvalues}
                                    setvalues={setcheckvalues}
                                    namevalue={[
                                        {names: '공동중개 진행 고객만 보기', values: 1},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                            </div>
                        </div>
                        <div style={{ width: 'auto' }}>
                            <div className='buttons_div_box ' style={{ width: 'auto'}}>
                                <Button
                                    buttonTxt={'이탈 고객 자동 관리'}
                                    className={`searchbutton active`}
                                    styles={buttonStyle}
                                    onPress={() => {
                                        popupOpen('이탈고객 자동 관리 현황', 2);
                                    }}
                                />
                                {
                                    customers?.filter(item => item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1)?.length ? <div className='buttons_div_box_cnt'>
                                        <p>{customers?.filter(item => item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1)?.length}</p> 
                                    </div> : <></>
                                }
                            </div>                                
                            <div style={{ width: 400 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder="고객번호, 고객명"
                                    setValue={setsearchvar}
                                    value={searchvar}
                                    name="mb_phone"
                                    allwaysclearflag={true}
                                    searchicons={true}
                                    style={{
                                        paddingLeft: 35
                                    }}
                                />                    
                            </div>            
                        </div>
                    </div>
                </div>
                <div 
                    style={{ 
                        width: searchwidth > MIN_WIDTH ? searchwidth-97 : MIN_WIDTH-97, height: 'calc(100% - 44px)',
                        overflow: 'hidden'
                    }}
                    className='productlistArea'
                >
                    <div className="productlist_th" style={{ paddingRight: 4 }}>
                        {productlistTh?.length > 0 && productlistTh?.map((x,i) => {
                            return (
                                <div 
                                    key={i}
                                    style={{ minWidth: x?.winsize ? x?.winsize : 76 }}
                                >
                                    {x?.key === 'status' ? 
                                    <div
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                                        }}
                                    >
                                        <div style={{ width: 50 }}>
                                        <Select 
                                            backgroundColors={'#F2F4F7'}
                                            selectClass={'simpleselect'}
                                            setValues={setselectorderby}
                                            values={selectorderby}
                                            selectData={( [{labels: '전체', values: ''}].concat(statusArrs) )}
                                        />                                              
                                        </div>
                                    </div>
                                    : 
                                    <>
                                    <div style={{ whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 12 }}>{x?.viewernames}</div>
                                    </>
                                     }
                                    
                                </div>
                            );
                        })}
                    </div>
                    <div className='product_scroll_list'>
                        {productlistTd?.length > 0 && productlistTd?.map((x,i) => {
                            let listClass = "";

                            return (
                                <div className={`productlist_td`}
                                    onDoubleClick={() => {
                                        setcustomerIdx(x?.idx);
                                        setcustomerdetailflag(true);
                                    }}
                                    onClick={() => {
                                        //setcustomerdetailflag(true);
                                        //console.log(x?.citysData);
                                        setpolylist([]);
                                        let polylists = [];
                                        x?.citysData?.map((x2, i2) => {
                                            if(x2?.polygon !==  null){
                                                let addDatas = {
                                                    coordinate: 'wgs84', 
                                                    options: {strokeColor: '#39f', strokeWeight: 3, strokeStyle: 'solid', strokeOpacity: 1, fillColor: '#39f', fillOpacity: 0.5, },
                                                    points: JSON.parse(x2?.polygon),
                                                    type: 'polygon'
                                                }
                                                polylists.push(addDatas);
                                            }
                                        });
                                        console.log(polylists);
                                        if(polylists?.length > 0){
                                            setlatlng({lat: polylists[0]?.points[0]?.y, lng: polylists[0]?.points[0]?.x });
                                            setpolylist(polylists);
                                        }
                                    }}                                     
                                >
                                {productlistTh?.length > 0 && productlistTh?.map((x2,i2) => {

                                    return (
                                        <div 
                                            key={i2}
                                            style={{ minWidth: x2?.winsize ? x2?.winsize : 76, cursor: 'pointer' }}
                                                                                      
                                        >
                                            {x2?.key === 'status' ? 
                                            <div 
                                                className={`setstyles ${x[x2?.key][1]}`}
                                                                                         
                                            >
                                                {x[x2?.key][2] === 'y' ? 
                                                    <Select 
                                                        selectClass={'simpleselect'}
                                                        setValues={(e) => {
                                                            let setDatas = statusArrs?.find(item => item?.idx*1 === e*1);
                                                            //console.log(setDatas);

                                                            setproductlistTd(productlistTd?.map(item => item?.idx*1 === x?.idx ? { ...item, statusname: setDatas?.title, status: setDatas?.arrays} : item ));
                                                            setsaveproductlistTd(saveproductlistTd?.map(item => item?.idx*1 === x?.idx ? { ...item, statusname: setDatas?.title, status: setDatas?.arrays} : item ));

                                                            let sender = {
                                                                idx: x?.idx,
                                                                status: e,
                                                            }
                                                            dispatch(loadingflas({ loading: true }));
                                                            APIS.postData('/v1/customer/statusUpdate', sender).then(({ data }) => {
                                                                if(data){
                                                                }
                                                            }).catch(({ response }) => {
                                                                const { data } = response;
                                                                console.log(response);
                                                            }).finally(() => {
                                                                dispatch(loadingflas({ loading: false }));
                                                            });     
                                                        }}
                                                        values={x[x2.key][3]*1}
                                                        selectData={statusArrs}
                                                    />                                                    
                                                :
                                                    x[x2?.key][0]
                                                }
                                            </div>
                                            : 

                                            <>
                                                {x2?.key === 'mediation' ? 
                                                    <div 
                                                        className={`${listClass}`}
                                                        style={{ cursor: 'pointer', whiteSpace: 'pre-wrap', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, flexDirection: 'column' }}
                                                    >
                                                        <p className={'stayviewer'+ (x[x2?.key][0] === 0 ? " grey":"")}>대기 {x[x2.key][0]}</p>
                                                        <p className={'stayviewer complate'+(x[x2?.key][1] === 0 ? " grey":"")}>진행 {x[x2.key][1]}</p>
                                                    </div>
                                                :
                                                <div 
                                                    
                                                    className={`${listClass}`}
                                                    style={{ 
                                                        cursor: 'pointer', textAlign: 'center',
                                                        width: x2?.winsize ? x2?.winsize : 76
                                                    }}
                                                >
                                                    {x[x2?.key]}
                                                </div>
                                                }

                                            </>
                                            }
                                        </div>
                                    );
                                })}                                        
                                </div>  
                            );
                        })}
                        {productlistTd?.length === 0 &&
                            <div className='nolistArea'>
                                등록된 고객이 없습니다.
                            </div>                        
                        }
                        <div ref={target} style={{ width: '100%', height: 1 }} />
                    </div>
                </div>
            </div>
            <div
                className={mapViewerflag === true && `mobileViews`}
                style={{ 
                    width: searchwidth2, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
                    backgroundImage: 'url(./images/samplemap.png)', backgroundPosition: 'center', backgroundSize: 'cover'
                }}
            >
                {mapshowhide === false &&
                <Map // 지도를 표시할 Container
                    id="map"
                    center={latlng}
                    style={{
                        // 지도의 크기
                        width: "100%",
                        height: "100%",
                    }}
                    onCenterChanged={(map) => {
                        const latlng = map.getCenter();
                        //setlatlng({lat: latlng.getLat(), lng: latlng.getLng() });
                    }}
                    level={3} // 지도의 확대 레벨
                    ref={mapRef}
                >                
                    {polylist.map(({ options, points }, i) => (
                        <Polygon key={i} path={pointsToPath(points)} {...options} />
                    ))}

                    {positions?.length > 0 &&
                    <MarkerClusterer
                        averageCenter={true} // 클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정
                        minLevel={5} // 클러스터 할 최소 지도 레벨
                        styles={[
                            { // calculator 각 사이 값 마다 적용될 스타일을 지정한다
                                width : '36px', height : '36px',
                                background: '#6164A5',
                                borderRadius: '12px',
                                border: '3px solid #fff',
                                color: '#fff',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                lineHeight: '30px'
                            },
                            {
                                width : '64px', height : '64px',
                                background: 'rgba(255, 255, 255, 1)',
                                borderRadius: '20px',
                                border: '4px solid #6164A5',
                                color: '#6164A5',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                lineHeight: '56px'
                            },
                            {
                                width : '64px', height : '64px',
                                background: 'rgba(255, 255, 255, 1)',
                                borderRadius: '20px',
                                border: '4px solid #6164A5',
                                color: '#6164A5',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                lineHeight: '56px'
                            },
                            {
                                width : '64px', height : '64px',
                                background: 'rgba(255, 255, 255, 1)',
                                borderRadius: '20px',
                                border: '4px solid #6164A5',
                                color: '#6164A5',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                lineHeight: '56px'
                            }
                        ]}
                        onClusterclick={(e) => {
                            console.log(e);
                        }}
                        ref={clusterer}
                    >
                        {positions?.length > 0 && positions?.map((pos) => (
                            <CustomOverlayMap
                                key={`${pos.lat}-${pos.lng}`}
                                position={{
                                lat: pos.lat,
                                lng: pos.lng,
                                }}
                            >
                                <div 
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        setproductIdx(pos?.idx);
                                        setproductdetailflag(true);                                        
                                    }}
                                >
                                    <img src="./images/icons/map-marker-svgrepo-com.svg" width='24' />              
                                </div>
                            </CustomOverlayMap>  
                        ))}
                    </MarkerClusterer>
                    }
                </Map>
                }
            </div>
        </Layout>
        <div style={{ left: moverleft }} className={`resizeArea scrollline`} onMouseDown={dragHandler}>
            <div>
                <svg width="58" height="58" xmlns="http://www.w3.org/2000/svg" >
                    <defs>
                        <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="57" id="filter0_d_5550_3834" width="57" x="0.5" y="0.5">
                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                            <feOffset dx="4" dy="4"/>
                            <feGaussianBlur stdDeviation="7.5"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend in2="BackgroundImageFix"/>
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_5550_3834"/>
                        </filter>
                    </defs>
                    <g className="layer">
                        <title>Layer 1</title>
                        <g id="material-symbols-light:arrow-drop-down-circle-rounded">
                            <g filter="url(#filter0_d_5550_3834)" id="Vector">
                                <ellipse cx="26.25" cy="25.17" fill="#ffffff" id="svg_3" rx="13.17" ry="13.17" stroke="#CCCCCC"/>
                            </g>
                            <path d="m33.43,25.77c0.13,-0.12 0.19,-0.27 0.19,-0.44c0,-0.16 -0.06,-0.31 -0.19,-0.44l-3.15,-3.14c-0.18,-0.19 -0.4,-0.23 -0.65,-0.13c-0.26,0.09 -0.38,0.28 -0.38,0.55l0,6.34c0,0.26 0.12,0.44 0.38,0.54c0.25,0.09 0.47,0.05 0.65,-0.14l3.15,-3.14z" fill="#999999" id="Vector_2"/>
                            <path d="m18.94,25.77c-0.13,-0.12 -0.19,-0.27 -0.19,-0.44c0,-0.16 0.06,-0.31 0.19,-0.44l3.14,-3.14c0.19,-0.19 0.41,-0.23 0.66,-0.13c0.25,0.09 0.38,0.28 0.38,0.55l0,6.34c0,0.26 -0.13,0.44 -0.38,0.54c-0.25,0.09 -0.47,0.05 -0.66,-0.14l-3.14,-3.14z" fill="#999999" id="Vector_3"/>
                        </g>
                    </g>
                </svg>                
            </div>
        </div>

        <div
            className='mobileViewer'
            style={{ 
                position: 'fixed', left: 0, bottom: 10, zIndex: 999,
                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
        >
            <div>
                <Button
                    buttonTxt={mapViewerflag === true ? '목록보기' : '지도보기'}
                    className={'linenormalbutton'}
                    styles={{
                        backgroundColor: '#fff', width: 160, borderRadius: 100
                    }}
                    onPress={() => { 
                        setmapViewerflag(!mapViewerflag);
                    }}

                />                                    
            </div>
        </div>

        {popupShow &&
            <MainPopup
                title={popupTitle}
                zIndexs={999}
                component={listContent()}
                setClose={() => {
                    setpopupShow(!popupShow);
                }}
            />
        }
        </>
    )
}
